/**
 * Onboarding Routes
 */

import type { RouteObject } from "react-router-dom";
import { ProtectedRoute } from "@/components/layout/protected-route";
import { ContractorOnboardingPage } from "./pages/contractor-onboarding";
import { DesignerOnboardingPage } from "./pages/designer-onboarding";
import { HomeownerOnboardingPage } from "./pages/homeowner-onboarding";
import { RealtorOnboardingPage } from "./pages/realtor-onboarding";
import { WelcomeScreen } from "./pages/welcomeUser";

export const onboardingRoutes: RouteObject[] = [
	{
		path: "/onboarding/homeowner",
		element: (
			<ProtectedRoute requireUserType="homeowner" hideAppShell>
				<HomeownerOnboardingPage />
			</ProtectedRoute>
		),
	},
	{
		path: "/onboarding/designer",
		element: (
			<ProtectedRoute requireUserType="designer" hideAppShell>
				<DesignerOnboardingPage />
			</ProtectedRoute>
		),
	},
	{
		path: "/onboarding/contractor",
		element: (
			<ProtectedRoute requireUserType="contractor" hideAppShell>
				<ContractorOnboardingPage />
			</ProtectedRoute>
		),
	},
	{
		path: "/onboarding/realtor",
		element: (
			<ProtectedRoute requireUserType="realtor" hideAppShell>
				<RealtorOnboardingPage />
			</ProtectedRoute>
		),
	},
	{
		path: "/welcome",
		element: <WelcomeScreen />,
	},
];
